module.exports = "/assets/data/bb836be769f2ba31261668cf9dc97500-FK1.data.json";